import React from 'react';
import SelectionButton from './buttons/SelectionButton';
import { useSelectionContext } from '../../../contexts/SelectionContext';

const SelectionCard = ({ title, text }) => {
    const { isItemSelected, selectionList, handleSelectionClick } =
        useSelectionContext();
    const selectionItems = selectionList.map((selection) => {
        return (
            <li
                key={'select-' + selection.topic}
                className={`h-14 rounded cursor-pointer ${
                    isItemSelected(selection.topic) ? 'bg-in-card-selected' : ''
                }`}
            >
                <SelectionButton
                    item={selection.topic}
                    clickHandler={handleSelectionClick}
                    isSelected={isItemSelected(selection.topic)}
                />
            </li>
        );
    });
    return (
        <div className="card flex flex-col w-full lg:w-4/12 xl:w-3/12">
            <h1 className="card-title">{title}</h1>
            {text && <span className="mt-4 text-card-text-color">{text}</span>}

            <div className="pt-6 mt-auto">
                <ul>{selectionItems}</ul>
            </div>
        </div>
    );
};

export default SelectionCard;
